<template lang="html">
  <span v-if="count" :class="['badge-counter', `bg-${color}`]">
    <div class="badge-count">
      {{ count }}
    </div>
  </span>
</template>

<script>
export default {
  props: {
    count: { type: Number | null },
    color: { type: String, default: () => 'red' }
  }
}
</script>

<style lang="scss">
  @import '../../scss/colors';

  .badge-count {
    display: inline;
    font-size: 0.85rem;
    margin-left: -1px;
  }

  .badge-counter {
    display: inline-block;
    font-size: 60.5%;
    background-color: #777;
    border-radius: 50%;
    width: 1.25rem;
    height: 1.25rem;
    color: white;
    font-weight: bold;
    text-align: center;
    margin: auto;
    vertical-align: text-top;
    padding-top: 0;
    padding-bottom: 0;

    &.bg-red {
      background-color: #FF1818;
    }

    &.bg-primary {
      background-color: $primary;
    }

    &.bg-blue {
      background-color: $blue;
    }

    &.bg-purple {
      background-color: $purple;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/BadgeCounter.vue